import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";
export const getAllWorkingStatusData = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getAllWorkingStatus${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const postWorkingStatus = (data, token) =>
  axios.post(`${baseUrl}/insertWorkingStatusManually`, data, {
    headers: {
      authorization: token,
    },
  });

export const inserClockInByUser = (token) => {
  let url = `${baseUrl}/insertClockInByUser`;
  return axios.post(
    url,
    {},
    {
      headers: {
        authorization: token,
      },
    }
  );
};
export const getWorkingStatusById = (id, token) => {
  let url = `${baseUrl}/getWorkingStatusbyID/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const deleteWorkingStatus = (id, token) =>
  axios.delete(`${baseUrl}/deleteWorkingStatus/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const updateWorkingStatus = (id, data, token) =>
  axios.put(`${baseUrl}/updateWorkingStaus/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
export const getWorkingStatusByUserId = (token) => {
  let url = `${baseUrl}/getWorkingStatusbyUserID`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
